module.exports = __webpack_public_path__ + "img/self-help.86c2e7e6.svg";